// slugs whose title needs a real hyphen, which the generic hyphen-to-space
// conversion below would drop
const TITLE_OVERRIDES: Record<string, string> = {
  'top-5-incomplete-driver-no-show-cities':
    'Top 5 Incomplete - Driver No Show Cities',
};

export const formatTitle = (segment: string): string => {
  if (TITLE_OVERRIDES[segment]) return TITLE_OVERRIDES[segment];

  return segment
    .replace(/-/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());
};
